<template>
    <div class="flex flex-col items-center">
        <div class="relative flex items-center justify-center p-1 border-2 games-islem-tahmin-border-color-secondery w-9 h-9 rounded-full shadow-sm games-islem-tahmin-rounded-gridant hover:bg-white cursor-pointer"
        :class="phoneScreen.landscape ? 'sm:w-10 sm:h-10  lg:w-12 lg:h-12 lg:p-3' : 'lg:w-12 lg:h-12 lg:p-3'"
        >
            <img class="w-full" :src="`/img/games/islem_tahmin/${svg}.svg`" alt="">
            <div class="absolute -top-2 -right-2 bg-white px-2 rounded-lg border border-black" v-if="number || number == 0">{{ number }}</div>
        </div>
        <div class="text-xs"  :class="phoneScreen.landscape ? 'sm:text-sm lg:text-sm' : 'lg:text-sm'">{{ title }}</div>
    </div>
</template>


<script setup>
import {defineProps} from 'vue'
import {useScreen} from 'vue-screen'

const phoneScreen = useScreen()
const props = defineProps(['title', 'svg', 'number'])

</script>
